import { render, staticRenderFns } from "./emailSettingsElement.vue?vue&type=template&id=298829a2&scoped=true&"
import script from "./emailSettingsElement.vue?vue&type=script&lang=js&"
export * from "./emailSettingsElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298829a2",
  null
  
)

export default component.exports